import HomeChatting from "../components/Home/HomeChatting/HomeChatting";
import HomeRooms from "../components/Home/HomeRooms/HomeRooms";
import HomeMembers from "../components/Home/HomeMembers/HomeMembers";
import HomeNotice from "../components/Home/HomeNotice/HomeNotice";
import HomeHeader from "../components/Home/HomeHeader";
import { useRecoilState } from "recoil";
import homeState from "../atoms/home";
import { useEffect } from "react";
import emitGetUsers from "../connector/emits/getUsers";
import emitGetMessages from "../connector/emits/getMessages";
import emitGetMyInfo from "../connector/emits/getMyInfo";
import emitJoinRoom from "../connector/emits/joinRoom";

function Home() {
  const [home] = useRecoilState(homeState);

  useEffect(() => {
    emitGetMyInfo();
    // 'square' 방에 join 해야 (구버전 서버에서) 실시간 RECEIVE_MESSAGE 를 받는다.
    emitJoinRoom('square', '');
    emitGetUsers('square');
    emitGetMessages('square');

    // 폴백: broadcast(RECEIVE_MESSAGE) 푸시가 유실되는 환경에서도
    // 새로고침과 동일한 GET_MESSAGES 방식으로 메시지를 주기적으로 동기화한다.
    const pollId = setInterval(() => {
      emitGetMessages('square');
    }, 2500);

    return () => clearInterval(pollId);
  }, []);

  return (
    <div>
      <HomeHeader />
      {
        {
          'chatting': <HomeChatting />,
          'rooms': <HomeRooms />,
          'members': <HomeMembers />,
          'notice': <HomeNotice />,
        }[home.menu]
      }
      
    </div>
  );
}

export default Home;
